export default function setProductAction(product) {
    return {
        type: 'SET_PRODUCT',
        payload: product
    }

}